import { Create } from 'react-admin'

import EbookForm from './EbookForm'

const EbookCreate = props => (
  <Create redirect="list" {...props}>
    <EbookForm permissions={props.permissions} />
  </Create>
)

export default EbookCreate
